import ApiService from 'services/ApiService';

import { OLIcon, LsPoint, OLPolygon, OLPoint } from '../ls-openlayers';

import defColors from 'utils/defColors';
import { getWebsocketHost, repeatEffect, settingsConfig } from 'utils/commonFunc';

export class LayerTrafficLink {

    constructor(map) {        
        this.map = map;
        this.layerIndex = 1;
        this.layerName = "linkLayer";        
        this.map.addVectorLayer(this.layerIndex, this.layerName);
        this.setData();
    }

    setData = function () {
        const map = this.map;
        const layerName = this.layerName;
        ApiService.get("dashboard/Map/GeoJson").then(response => {
            if (response.status === 200) {
                const data = response.data;
                const link = data.link2;
        
                let id, name, x, y, olData, popupHtml, geom, speed;
                for (let i = 0; i < link.features.length; i++) {

                    id = link.features[i].properties.LINK2_ID;
                    name = link.features[i].properties.name;
                    speed = link.features[i].properties.speed;

                    olData = new OLPolygon(layerName);
                    for (let j = 0; j < link.features[i].geometry.coordinates[0].length; j++) {
                        geom = link.features[i].geometry.coordinates[0]
                        x = geom[j][0];
                        y = geom[j][1];
                        olData.addPoint(new LsPoint(x, y));
                    }                    
                    olData.userData.set("id", id);
                    olData.userData.set("name", "name");
                    olData.userData.set("speed", "speed");
                    olData.userData.set("type", "link");
                    map.addData(olData);
                }
                this.updData();
            }
        })
    }

    updData = function () {
        const map = this.map;
        const layerName = this.layerName;
        return repeatEffect(
            async () => {
                const response = await ApiService.get("dashboard/Map/UpdateLink2Data")
                if (response.status === 200) {
                    const data = response.data;
                    const dataList = map.dataList.filter(x => x.lyrId == layerName);

                    let id, lvl, color;
                    for(let i = 0; i < dataList.length; i++) {
                        id = dataList[i].userData.get("id");
                        lvl = data.link2SpdRows[id];
                        switch (lvl) {
                            case 1:
                                color = defColors.trafficColors[2];
                                break;
                            case 2:
                                color = defColors.trafficColors[1];
                                break;
                            case 3:
                                color = defColors.trafficColors[0];
                                break;
                            default:
                                break;
                        }
                        dataList[i].userData.set("lvl", lvl);
                        color += "aa";
                        dataList[i].fill.color = color;
                    }
                    map.draw();
                }
            },
            settingsConfig().contentUpdateDelaySec)
    }
}

export class LayerTrafficLos {

    constructor(map) {        
        this.map = map;
        this.layerIndex = 1;
        this.layerName = "losLayer";        
        this.map.addVectorLayer(this.layerIndex, this.layerName);
        this.setData();
    }

    setData = function () {
        this.updData();
    }

    updData = function () {
        const map = this.map;
        const layerName = this.layerName;
        return repeatEffect(
            async () => {
                const response = await ApiService.get("newdashboard/gis/GetSmtLos")
                if (response.status === 200) {                    
                    const data = response.data;

                    let id, name, x, y, los, olData, popupHtml;                
                    let fillColor, strokeColor, label;
                    let strokeOpacity = 0.5, fillOpacity = 0.8, strokeWidth = 8;
                    for(let i = 0; i < data.rows.length; i++) {
                        
                        id = data.rows[i]['crsrdId'];
                        name = data.rows[i]['crsrdNm'];
                        x = data.rows[i]['x'];
                        y = data.rows[i]['y'];
                        los = data.rows[i]['los'];
                        
                        olData = new OLPoint(layerName);
                        olData.set(new LsPoint(x, y));
                        olData.userData.set("id", id);
                        olData.userData.set("name", name);
                        olData.userData.set("los", los);
                        olData.userData.set("x", x);
                        olData.userData.set("y", y);
                        olData.userData.set("type", "los");
                        
                        fillColor = `rgba(100, 100, 100, ${fillOpacity})`;
                        if(los >= 0 && los <= 15) { fillColor = `rgba(60, 155, 58, ${fillOpacity})`; label = 'A'; }
                        else if(los >= 16 && los <= 30) { fillColor = `rgba(139, 220, 36, ${fillOpacity})`; label = 'B'; }
                        else if(los >= 31 && los <= 50) { fillColor = `rgba(251, 255, 48, ${fillOpacity})`; label = 'C'; }
                        else if(los >= 51 && los <= 70) { fillColor = `rgba(255, 196, 45, ${fillOpacity})`; label = 'D'; }
                        else if(los >= 71 && los <= 100) { fillColor = `rgba(243, 118, 27, ${fillOpacity})`; label = 'E'; }
                        else if(los >= 101 && los <= 220) { fillColor = `rgba(224, 56, 56, ${fillOpacity})`; label = 'F'; }
                        else { label = ''; }
                        
                        strokeColor = `rgba(100, 100, 100, ${strokeOpacity})`;
                        if(los >= 0 && los <= 15) { strokeColor = `rgba(60, 155, 58, ${strokeOpacity})`; }
                        else if(los >= 16 && los <= 30) { strokeColor = `rgba(139, 220, 36, ${strokeOpacity})`; }
                        else if(los >= 31 && los <= 50) { strokeColor = `rgba(251, 255, 48, ${strokeOpacity})`; }
                        else if(los >= 51 && los <= 70) { strokeColor = `rgba(255, 196, 45, ${strokeOpacity})`; }
                        else if(los >= 71 && los <= 100) { strokeColor = `rgba(243, 118, 27, ${strokeOpacity})`; }
                        else if(los >= 101 && los <= 220) { strokeColor = `rgba(224, 56, 56, ${strokeOpacity})`; }

                        olData.style.fill.color = fillColor;
                        olData.style.stroke.color = strokeColor;
                        olData.style.stroke.width = strokeWidth;
                        olData.style.text.text = '';
                        // olData.style.text.text = label;
                        // olData.style.text.font = '32px Arial';
                        // olData.style.text.fill.color = '#fff';
                        // olData.style.text.stroke.color = '#000';
                        // olData.style.text.stroke.width = 4;

                        map.addData(olData); 
                    }
                    map.draw();
                }
            },
            3600)
    }
}